<div class="md-form md-outline">
  <jhi-bary-icon *ngIf="icon" [faDirective]="FAR" [icon]="icon" class="suffix"></jhi-bary-icon>
  <input
    mdbInput
    type="text"
    class="form-control"
    (keypress)="keyPress($event)"
    [formControl]="control"
    [id]="id"
    [mdbValidate]="true"
    [validateSuccess]="false"
    [name]="id"
    jhiMarkAsterisk
  />
  <label [for]="id">{{ label }}</label>
  <mdb-error *ngIf="control && control.invalid && (control.dirty || control.touched)">
    <span *ngIf="control.hasError('required')" jhiTranslate="ERROR.REQUIRED_FIELD"></span>
    <span *ngIf="control.hasError('incorrectPhoneNumber')" jhiTranslate="components.inputs.phone.incorrectPhoneNumber"></span>
    <span *ngIf="control.hasError('maxlength')" jhiTranslate="components.inputs.errors.max" [translateValues]="{ max: control!.errors!['maxlength'].requiredLength + 1 }"></span>
    <span *ngIf="control.hasError('minlength')" jhiTranslate="components.inputs.errors.min" [translateValues]="{ min: control!.errors!['minlength'].requiredLength - 1 }"></span>
  </mdb-error>
</div>
